import React from "react";
import "./WhyTrustUsSection.css";
import { ShieldCheck, Clock, IndianRupee, MapPin, Headphones, Award } from "lucide-react";

const trustPoints = [
  { icon: ShieldCheck, title: "100% Secure Transactions", desc: "Every transaction is encrypted and fully secure. We follow strict security protocols to protect your data." },
  { icon: Clock, title: "8+ Years of Experience", desc: "Serving Chennai since 2016. We have built a loyal customer base through consistent quality service." },
  { icon: IndianRupee, title: "No Hidden Charges", desc: "What you see is what you pay. Our rates are transparent — 1.79% for Visa and 1.98% for MasterCard/RuPay." },
  { icon: MapPin, title: "5+ Convenient Locations", desc: "Visit us at Velachery, Jafferkhanpet, Pallavaram, Thiruvanmiyur, or Arumbakkam — whichever is closest." },
  { icon: Headphones, title: "24/7 Customer Support", desc: "Call us anytime at 9884135738 or 6385417845. Our team is always ready to assist you." },
  { icon: Award, title: "Chennai's #1 Rated Service", desc: "Rated the best credit card swiping service in Chennai by thousands of verified customers." },
];

const WhyTrustUsSection = () => {
  return (
    <section id="Trust" className="trust-section">
      <div className="trust-container">
        
        <div className="trust-header fade-in-up">
          <h2 className="trust-title orange-gradient-text">
            Why Trust Us
          </h2>
          <p className="trust-subtitle">
            Your money is safe with us. Here's why thousands choose View Secure Technologies.
          </p>
        </div>

        <div className="trust-grid">
          {trustPoints.map((tp, i) => (
            <div 
              key={tp.title} 
              className="trust-card fade-in-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="trust-icon-box">
                <tp.icon className="trust-icon" size={28} />
              </div>
              <div className="trust-text-box">
                <h3 className="trust-card-title">{tp.title}</h3>
                <p className="trust-card-desc">{tp.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyTrustUsSection;